import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { spaceL, spaceXL } from '@xing-com/tokens';
import type { HeadlineProps } from '@xing-com/typography';
import { Headline } from '@xing-com/typography';

type Props = {
  titleKey: string;
  size?: HeadlineProps['size'];
  noMargin?: boolean;
  className?: string;
  titleAriaLabel?: string;
};

const StyledHeadline = styled(Headline)<{
  noMargin: boolean;
}>`
  margin-bottom: ${({ noMargin, size }) =>
    noMargin ? 0 : size === 'xxlarge' ? spaceXL : spaceL};
`;

export const ModuleTitle: React.FC<Props> = ({
  titleKey,
  size = 'xxlarge',
  noMargin,
  className,
  titleAriaLabel,
}) => (
  <StyledHeadline
    size={size}
    // @ts-expect-error FIXME: SC6
    noMargin={noMargin}
    className={className ?? ''}
    aria-label={titleAriaLabel}
  >
    <FormattedMessage id={titleKey} />
  </StyledHeadline>
);
